import { es } from 'date-fns/locale'

export { es }
export default es
